import React from 'react'
import Icon from 'decorators/Icon'

// eslint-disable-next-line react/prop-types
const IconCancel = ({ t, className, height, width, fill }) => (
  <svg xmlns='http://www.w3.org/2000/svg' xmlnsXlink='http://www.w3.org/1999/xlink'
    width={width} height={height} viewBox='0 0 25 25'>
    <defs>
      <path id='a' d='M0 0h25v25H0z' />
    </defs>
    <g fill='none' fillRule='evenodd'>
      <mask id='b'>
        <use xlinkHref='#a' />
      </mask>
      <use xlinkHref='#a' />
      <g fill={fill} mask='url(#b)'>
        <path d='M5.636 7.066c0-.317.12-.633.36-.872a1.18 1.18 0 0 1 1.693.02l5.284 5.516 5.348-5.45a1.18 1.18 0 0 1 1.692 0 1.235 1.235 0 0 1 0 1.724l-6.204 6.322c-.226.23-.533.359-.854.357a1.187 1.187 0 0 1-.849-.367L5.977 7.918a1.228 1.228 0 0 1-.34-.852'
        />
        <path d='M20.364 19.799c0 .317-.12.633-.36.872a1.18 1.18 0 0 1-1.693-.02l-5.284-5.516-5.348 5.45a1.18 1.18 0 0 1-1.692 0 1.235 1.235 0 0 1 0-1.724l6.204-6.322c.226-.23.533-.359.854-.357.32.002.625.134.849.367l6.129 6.398c.227.238.34.545.34.852'
        />
      </g>
    </g>
  </svg>
)

export default Icon(IconCancel)
